import React, { CSSProperties, FC } from 'react'
import { Inline } from '@shared/layout/Inline'
import {
	Arrow,
	Container,
	NewAchievementDescribe,
	Progress,
	ProgressFilled,
	Subtitle,
	Title,
} from './styles'

import LinkArrow from '@images/LinkArrow.svg'
import { useIonRouter } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'

interface NewAchievementProps {
	title: string
	description: string
	newAchievementDescription?: string
	percentage: number
	type?: 'unlocked' | 'in progress'
	style?: CSSProperties
}

export const Achievement: FC<NewAchievementProps> = ({
	title,
	description,
	percentage,
	newAchievementDescription,
	type = 'unlocked',
	style,
}) => {
	const nav = useIonRouter()

	return (
		<Container style={style} onClick={() => nav.push(ROUTES.overall.profile)}>
			<Inline justify={'space-between'} align={'flex-start'}>
				<div>
					<Title>{title}!</Title>
					<Subtitle>{description}</Subtitle>
				</div>
				<Arrow>
					<img src={LinkArrow} alt='Ссылка	' />
				</Arrow>
			</Inline>
			<div style={{ marginTop: 10, display: 'flex', flexDirection: 'column' }}>
				{type === 'unlocked' && (
					<NewAchievementDescribe>{newAchievementDescription}</NewAchievementDescribe>
				)}
				<Progress>
					<ProgressFilled $percentage={percentage} />
				</Progress>
			</div>
		</Container>
	)
}
